import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import React from "react";

export const ToastType = {
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
  INFO: "info",
};

export const notifyToast = (msg, type) => {
  switch (type) {
    case ToastType.SUCCESS:
      toast.success(msg);
      break;
    case ToastType.WARNING:
      toast.warning(msg);
      break;
    case ToastType.ERROR:
      toast.error(msg);
      break;
    case ToastType.INFO:
      toast.info(msg);
      break;
    default:
      toast(msg);
      break;
  }
};

export const AppToastMsg = () => {
  return (
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={true}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    />
  );
};
